module.exports = __webpack_public_path__ + "static/media/display-chart-up-circle-dollar.63729d58.svg";